import type { MaasModel } from '@/proto/agentplatform/v2/maas_pb';

export interface ModelGroup {
  label: string;
  models: MaasModel[];
}

export function groupModels(models: MaasModel[]): ModelGroup[] {
  const groupMap = new Map<string, MaasModel[]>();
  for (const m of models) {
    const type = m.modelType?.trim() || '其他';
    const list = groupMap.get(type);
    if (list) {
      list.push(m);
    } else {
      groupMap.set(type, [m]);
    }
  }
  const groups: ModelGroup[] = [];
  for (const [label, list] of groupMap.entries()) {
    list.sort((a, b) => a.name.localeCompare(b.name));
    groups.push({ label, models: list });
  }
  groups.sort((a, b) => a.label.localeCompare(b.label));
  return groups;
}

export function formatContextLength(cl: bigint): string {
  const n = Number(cl);
  if (n === 0) return '';
  if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, '')}M`;
  if (n >= 1_000) return `${Math.round(n / 1_000)}K`;
  return String(n);
}
